"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWrenchClockOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M6.53 23A3.49 3.49 0 014 21.93a3.57 3.57 0 01.06-5l7.07-7c-.71-1.79-.8-4.26 1.82-6.84a7.09 7.09 0 015-2 7 7 0 012.32.43l.26.11 1.3.61-.94 1-3.55 3.53c-.3.3-.3.35-.3.44s.14.54.7 1.12 1 .74 1.09.74c.08 0 .12 0 .37-.25l4.67-4.64.6 1.31c.09.21.14.35.14.35A7.05 7.05 0 0125 8.21a7.14 7.14 0 01-2.12 5c-2.63 2.57-5.07 2.46-6.83 1.74L9 22a3.51 3.51 0 01-2.47 1zM17.92 3a5 5 0 00-3.57 1.48c-1.73 1.7-2.08 3.34-1.13 5.17l.34.66-.65.64-7.45 7.39a1.57 1.57 0 000 2.2 1.48 1.48 0 001.05.46 1.52 1.52 0 001.08-.44l8.08-8 .65.35c1.78 1 3.42.63 5.15-1.08A5.11 5.11 0 0023 8.19v-.32l-2.33 2.32a2.43 2.43 0 01-1.81.88 3.71 3.71 0 01-2.54-1.35A3.65 3.65 0 0115 7.15a2.39 2.39 0 01.84-1.75L18.28 3zM22 31a7 7 0 117-7 7 7 0 01-7 7zm0-12a5 5 0 105 5 5 5 0 00-5-5z" }),
        React.createElement("path", { d: "M23.01 26.42L21 24.41V21h2v2.59l1.42 1.42-1.41 1.41z" })));
}
exports.default = SvgWrenchClockOutline;
//# sourceMappingURL=WrenchClockOutline.js.map